import { MouseEventHandler, ReactNode } from 'react';
import { IconButton, SxProps } from '@coolblue-development/freddy';

interface FabProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  'data-testid'?: string;
  sx?: SxProps;
}

/**
 * Freddy has no Fab component yet. Freddy's IconButton with shape="round" and
 * size="xlarge" produces the same 48px circular button as Becky's Fab (icon is a
 * fixed 16px, padded by the xlarge spacing token on each side), so this is a thin
 * wrapper rather than a from-scratch component.
 */
export const Fab = ({ children, onClick, 'data-testid': dataTestId, sx }: FabProps): JSX.Element => (
  <IconButton
    variant="solid"
    iconColor="base"
    shape="round"
    size="xlarge"
    onClick={onClick}
    data-testid={dataTestId}
    sx={sx}
  >
    {children}
  </IconButton>
);

export default Fab;
